import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
import { useAuth } from '../context/AuthContext';
import { resolveStorePurchase } from './storePurchases';

/**
 * CORE-1773 — можно ли показать покупку подписки в сторе. `null` — ещё решаем:
 * экран не показывает ни цену, ни кнопку. Гость — `false`: покупка ложится на
 * аккаунт, сперва войти.
 */
export function useCanBuyInStore(): boolean | null {
  const { isAuthenticated, user } = useAuth();
  const userId = isAuthenticated ? user?.id ?? null : null;
  const [allowed, setAllowed] = useState<boolean | null>(Platform.OS === 'web' ? false : null);
  useEffect(() => {
    if (Platform.OS === 'web') return;
    if (!userId) { setAllowed(false); return; }
    let alive = true;
    void resolveStorePurchase(userId).then((d) => { if (alive) setAllowed(d.allowed); });
    return () => { alive = false; };
  }, [userId]);
  return allowed;
}
